export default [
  {
    path: 'direction',
    name: 'direction',
    component: () => import('@/views/pages/direction/Direction.vue'),
    meta: {
      pageTitle: 'Direction',
      breadcrumb: [
        {
          text: 'Direction',
          active: true,
        },
      ],
      resource: 'All',
    },
  },
  {
    path: 'direction/:id',
    name: 'direction-view',
    component: () => import('@/views/pages/direction/View.vue'),
    meta: {
      pageTitle: 'View',
      breadcrumb: [
        {
          to: { name: 'direction' },
          text: 'Directions',
          active: false,
        },
        {
          text: 'View',
          active: true,
        },
      ],
      resource: 'All',
    },
  },
]
